import { styled } from '@mui/material/styles';

// Fixed-height phone frame with internal scrolling so embedded previews behave
// as on a real phone (sticky headers, bottom sheets) instead of growing with content.
export const PhonePreviewFrame = styled('div')({
    width: '100%',
    maxWidth: 375,
    height: 660,
    margin: '0 auto',
    backgroundColor: '#fff',
    borderRadius: 24,
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.2)',
    overflow: 'hidden',
});
